import React, { useRef, useState } from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { Commas } from "../../Common/AllDateTimeReleventFormate";
import BasicChartLineGraphTask from "../../Common/Graphs/BasicChartLineGraphTask";
import PaiChartGraphReview from "../../Common/Graphs/PaiChartGraphReview";
import TimeWiseFilter from "./GraphFilter/TimeWiseFilter";
import project from "../../.././assests/imgs/project.svg"
import contest from "../../.././assests/imgs/contest.svg"
import job from "../../.././assests/imgs/job.svg"
import packages from "../../.././assests/imgs/package.svg"
import ots from "../../.././assests/imgs/ots-overview.svg"
import rental from "../../.././assests/imgs/rental.svg"
import buy from "../../.././assests/imgs/sale.svg"
import pbp from "../../.././assests/imgs/pb-status.svg"
import wbo from "../../.././assests/imgs/wbo.svg"
import ptj from "../../.././assests/imgs/ptj.svg"
import tai from "../../.././assests/imgs/tai.svg"
import bsa from "../../.././assests/imgs/bsa.svg"
import RatingReviewsComponent from "../../Common/RatingReviewsComponent";
import { useSelector } from "react-redux";
import ExportButtons from "../../Common/ExportButtons";
import CompanyUserTabs from "./CompanyUserTabs";
import CompanyExpertTabs from "./CompanyExpertTabs";






export default function Overview({ data }) {
  const [firstdate, setFirstdate] = useState("");
  const [lastdate, setLastdate] = useState("");
  const [type, setType] = useState(1);
  const profiledata = useSelector(({ profile: { profiledata } }) => profiledata,);
  const chartRef = useRef(null); // ✅ Add ref for export
  const [activeTab, setActiveTab] = useState("overview");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  return (
    <div>
      <div>
        {(profiledata?.company || profiledata?.expert) ?
          <>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab == "overview" ? "active" : ""}`}
                  onClick={() => handleTabChange("overview")}
                >
                  Company / Expert
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab == "myBusiness" ? "active" : ""}`}
                  onClick={() => handleTabChange("myBusiness")}
                >
                  User
                </a>
              </li>
            </ul>
            <div className="tab-content">
              <div className="row report-row">
                {activeTab == "overview" &&
                  <CompanyUserTabs data={data} type={1} />
                }
                {activeTab == "myBusiness" &&
                  <CompanyUserTabs data={data} type={0} />
                }
              </div>
            </div>
          </> :
          <div className="tab-content">
            <div className="row report-row">
              <CompanyUserTabs data={data} />
            </div>
          </div>
        }


        <div className="row report-row">

          {/* {(profiledata?.company || profiledata?.expert) ?
            <CompanyExpertTabs data={data} /> :
            <CompanyUserTabs data={data} />
          } */}

          {/* <>
            <div className="col-md-4 report-order">
              <div className="report-first">
                <h5>
                  {" "}
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/background-dollar.png`}
                    alt=""
                  />
                  Total Earnings
                </h5>
                <div className="row total-row">
                  <div className="col-md-12 total-earning">
                    <p>Total Earnings Since Joining</p>
                    <h2>{Commas(data?.total_earnings ? data?.total_earnings : "")}</h2>
                  </div>
                  <div className="col-md-12 total-earning border-total">
                    <p>Total Earnings From Post & Browse Projects (PBP)</p>
                    <h2>{Commas(data?.total_earnings_project ? data?.total_earnings_project : "")}</h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 report-order">
              <div className="report-first">
                <h5>
                  {" "}
                  <img
                    src={`${pbp}`}
                    alt=""
                  />
                  PBP Status
                </h5>
                <div className="row total-row">
                  <div className="col-md-6 total-earning">
                    <p>Pending Request</p>{" "}
                    <h2>{data?.project && data?.project?.pending_project}</h2>
                  </div>
                  <div className="col-md-6 total-earning earning-right">
                    <p>Completed Post & Browse Projects (PBP)</p>
                    <h2>{data?.project && data?.project?.completed_project}</h2>
                  </div>
                  <div className="col-md-6 total-earning border-total">
                    <p>Active Post & Browse Projects (PBP)</p>
                    <h2>{data?.project && data?.project?.active_project}</h2>
                  </div>
                  <div className="col-md-6 total-earning border-total earning-right">
                    <p>Total Post & Browse Projects (PBP)</p>
                    <h2>{data?.project && data?.project?.total_project}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 report-order">
              <div className="report-first">
                <h5>
                  {" "}
                  <img
                    src={`${wbo}`}
                    alt=""
                  />
                  WBO Status
                </h5>
                <div className="row total-row">
                  <div className="col-md-6 total-earning">
                    <p>Pending Request</p>{" "}
                    <h2>{data?.contest && data?.contest?.pending_contest}</h2>
                  </div>
                  <div className="col-md-6 total-earning earning-right">
                    <p>Completed Win business Opportunities (WBO)</p>
                    <h2>{data?.contest && data?.contest?.completed_contest}</h2>
                  </div>
                  <div className="col-md-6 total-earning border-total">
                    <p>Active Win business Opportunities (WBO)</p>
                    <h2>{data?.contest && data?.contest?.active_contest}</h2>
                  </div>
                  <div className="col-md-6 total-earning border-total earning-right">
                    <p>Total Win business Opportunities (WBO)</p>
                    <h2>{data?.contest && data?.contest?.total_contest}</h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 report-order">
              <div className="report-first">
                <h5>
                  {" "}
                  <img
                    src={`${ptj}`}
                    alt=""
                  />
                  PTJ Status
                </h5>
                <div className="row total-row">
                  <div className="col-md-6 total-earning">
                    <p>Pending Request</p>{" "}
                    <h2>{data?.job && data?.job?.pending_job}</h2>
                  </div>
                  <div className="col-md-6 total-earning earning-right">
                    <p>Completed Part time Job (PTJ)</p>
                    <h2>{data?.job && data?.job?.completed_job}</h2>
                  </div>
                  <div className="col-md-6 total-earning border-total">
                    <p>Active Part time Job (PTJ)</p>
                    <h2>{data?.job && data?.job?.active_job}</h2>
                  </div>
                  <div className="col-md-6 total-earning border-total earning-right">
                    <p>Total Part time Job (PTJ)</p>
                    <h2>{data?.job && data?.job?.total_job}</h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 report-order">
              <div className="report-first">
                <h5>
                  {" "}
                  <img
                    src={`${ots}`}
                    alt=""
                  />
                  OTS Status
                </h5>
                <div className="row total-row">
                  <div className="col-md-6 total-earning">
                    <p>Pending Request</p>{" "}
                    <h2>{data?.bxp_request && data?.bxp_request?.pending_bxp}</h2>
                  </div>
                  <div className="col-md-6 total-earning earning-right">
                    <p>Completed Package Service</p>
                    <h2>
                      {data?.bxp_request && data?.bxp_request?.completed_bxp}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning border-total">
                    <p>Active Package Service</p>
                    <h2>{data?.bxp_request && data?.bxp_request?.active_bxp}</h2>
                  </div>
                  <div className="col-md-6 total-earning border-total earning-right">
                    <p>Total Package Service</p>
                    <h2>{data?.bxp_request && data?.bxp_request?.total_bxp}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 report-order">
              <div className="report-first">
                <h5>
                  {" "}
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/project-profiency.png`}
                    alt=""
                  />
                  BSM Status
                </h5>
                <div className="row total-row">
                  <div className="col-md-6 total-earning">
                    <p>Pending Request</p>{" "}
                    <h2>
                      {data?.sale_request && data?.sale_request?.pending_sale}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning earning-right">
                    <p>Completed sale_requests</p>
                    <h2>
                      {data?.sale_request && data?.sale_request?.completed_sale}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning border-total">
                    <p>Active sale_requests</p>
                    <h2>
                      {data?.sale_request && data?.sale_request?.active_sale}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning border-total earning-right">
                    <p>Total sale_requests</p>
                    <h2>
                      {data?.sale_request && data?.sale_request?.total_sale}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 report-order">
              <div className="report-first">
                <h5>
                  {" "}
                  <img
                    src={`${tai}`}
                    alt=""
                  />
                  TAI Status
                </h5>
                <div className="row total-row">
                  <div className="col-md-6 total-earning">
                    <p>Pending Request</p>{" "}
                    <h2>
                      {data?.rental_request &&
                        data?.rental_request?.pending_rental}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning earning-right">
                    <p>Completed Rental</p>
                    <h2>
                      {data?.rental_request &&
                        data?.rental_request?.completed_rental}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning border-total">
                    <p>Active Rental</p>
                    <h2>
                      {data?.rental_request &&
                        data?.rental_request?.active_rental}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning border-total earning-right">
                    <p>Total Rental</p>
                    <h2>
                      {data?.rental_request && data?.rental_request?.total_rental}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 report-order">
              <div className="report-first">
                <h5>
                  {" "}
                  <img
                    src={`${bsa}`}
                    alt=""
                  />
                  BSA Status
                </h5>
                <div className="row total-row">
                  <div className="col-md-6 total-earning">
                    <p>Pending Request</p>{" "}
                    <h2>
                      {data?.auction_bid && data?.auction_bid?.pending_auction}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning earning-right">
                    <p>Completed Buy & Sell with Auction (BSA)</p>
                    <h2>
                      {data?.auction_bid && data?.auction_bid?.completed_auction}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning border-total">
                    <p>Active Buy & Sell with Auction (BSA)</p>
                    <h2>
                      {data?.auction_bid && data?.auction_bid?.active_auction}
                    </h2>
                  </div>
                  <div className="col-md-6 total-earning border-total earning-right">
                    <p>Total Buy & Sell with Auction (BSA)</p>
                    <h2>
                      {data?.auction_bid && data?.auction_bid?.total_auction}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </> */}
          <div className="col-md-12 wallet-calendar">
            <div className="d-flex align-items-center justify-content-between pb-3 ">
              <h4 className="p-0">Team Task </h4>
              <ExportButtons targetRef={chartRef} filename="team_task_report" data={data?.task} />

            </div>
            <TimeWiseFilter
              setFirstdate={setFirstdate}
              setLastdate={setLastdate}
              setType={setType}
              start_date={firstdate}
              end_date={lastdate}
            />
            <div ref={chartRef}>
              <BasicChartLineGraphTask
                task={data?.task}
                start_date={firstdate}
                end_date={lastdate}
                type={type}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="average-rating">
              <h4>Average Rating and Breakdown</h4>
              <PaiChartGraphReview reviews={data?.rating_star} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="customer-satisfication">
              <h6>Customer Satisfaction</h6>
              <div className="row">
                <div className="col-md-6 satisfication-border">
                  <div>
                    <p>Responses Received</p>
                    <h5>{data?.total_rating} Customer</h5>
                  </div>
                </div>
                <div className="col-md-6 satisfication-border satisfication-left positive">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/thumbs-up.png`}
                    alt=""
                  />
                  <div>
                    <p>Good Responses</p>
                    <h5>{data?.good_response?.count} </h5>
                  </div>
                  <div className="progress-sec">
                    <div className="progress">
                      <div
                        className="progress-bar"
                        style={{ width: `${data?.good_response?.percent}%` }}
                      ></div>
                    </div>
                    <p>{data?.good_response?.percent}%</p>
                  </div>
                </div>
                <div className="col-md-6 satisfication-border sat-bottom smile-sec ">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/face-neutral.png`}
                    alt=""
                  />
                  <div>
                    <p>Avgrage Response</p>
                    <h5>{data?.avg_response?.count} </h5>
                  </div>
                  <div className="progress-sec">
                    <div className="progress">
                      <div
                        className="progress-bar"
                        style={{ width: `${data?.avg_response?.percent}%` }}
                      ></div>
                    </div>
                    <p>{data?.avg_response?.percent}%</p>
                  </div>
                </div>
                <div className="col-md-6 satisfication-border satisfication-left sat-bottom negative">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/thumbs-down.png`}
                    alt=""
                  />
                  <div>
                    <p>Negative Response</p>
                    <h5>{data?.bad_response?.count} </h5>
                  </div>

                  <div className="progress-sec">
                    <div className="progress">
                      <div
                        className="progress-bar"
                        style={{ width: `${data?.bad_response?.percent}%` }}
                      ></div>
                    </div>
                    <p>{data?.bad_response?.percent}%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="report-review w-100 col-md-12">
            <RatingReviewsComponent formData={profiledata} rating={true} />
          </div>
        </div>
      </div>
    </div>
  );
}
